import { useState } from "react";
import SortImg from "assets/icons/sort.svg";
import { navigate } from "@reach/router";
import { ICustomer } from "types";
import "./style.scss";

type Props = {
  customers: ICustomer[];
};

export const CustomerTable: React.FC<Props> = ({
	customers,
}) => {
  const [checkStatus, setCheckStatus] = useState<boolean>(false);
  const checkAll = (status: any) => {
    setCheckStatus(status);
  };

  return (
    <section className="table-component">
      <table className="table-component_table">
        <thead>
          <tr className="table-component_head">
            <th className="table-component_table-th" style={{width: "16%"}} scope="col">
              <div>
                <span>PHONE NUMBER</span>
                <img
                  src={SortImg}
                  alt="sort"
                  className="table-component_table-th-sort"
                />
              </div>
            </th>
            <th className="table-component_table-th" style={{width: "13%"}} scope="col">
              <div>
                <span>FIRST NAME</span>
                <img
                  src={SortImg}
                  alt="sort"
                  className="table-component_table-th-sort"
                />
              </div>
            </th>
            <th className="table-component_table-th" style={{width: "12%"}} scope="col">
              <div>
                <span>LAST NAME</span>
                <img
                  src={SortImg}
                  alt="sort"
                  className="table-component_table-th-sort"
                />
              </div>
            </th>
            <th className="table-component_table-th" style={{width: "15%"}} scope="col">
              <div>
                <span>ADDRESS</span>
                <img
                  src={SortImg}
                  alt="sort"
                  className="table-component_table-th-sort"
                />
              </div>
            </th>
            <th className="table-component_table-th" style={{width: "12%"}} scope="col">
              <div>
                <span>CITY</span>
                <img
                  src={SortImg}
                  alt="sort"
                  className="table-component_table-th-sort"
                />
              </div>
            </th>
            <th className="table-component_table-th" style={{width: "8%"}} scope="col">
              <div>
                <span>STATE</span>
                <img
                  src={SortImg}
                  alt="sort"
                  className="table-component_table-th-sort"
                />
              </div>
            </th>
            <th className="table-component_table-th" style={{width: "12%"}} scope="col">
              <div>
                <span>ZIP CODE</span>
                <img
                  src={SortImg}
                  alt="sort"
                  className="table-component_table-th-sort"
                />
              </div>
            </th>
            <th className="table-component_table-th" style={{width: "12%"}} scope="col">
              <div>
                <span>ACTION</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {customers &&
            customers.length > 0 &&
            customers.map((data?: any, index?: number) => (
              <tr
                key={data.mastercustomerid}
                className={
                  index != undefined && index % 2 == 0
                    ? "table-component_table-tr"
                    : "table-component_table-tr-even"
                }
              >
                <td className="table-component_table-td">
                  <span>{data.primaryphone == null ? "N/A" : data.primaryphone}</span>
                </td>
                <td className="table-component_table-td">
                  <span>{data.firstname == null ? "N/A" : data.firstname}</span>
                </td>
                <td className="table-component_table-td">
                  <span>{data.lastname == null ? "N/A" : data.lastname}</span>
                </td>
                <td className="table-component_table-td">
                  <span>{data.address1 == null ? "N/A" : data.address1}</span>
                </td>
                <td className="table-component_table-td">
                  <span>{data.city == null ? "N/A" : data.city}</span>
                </td>
                <td className="table-component_table-td">
                  <span>{data.state == null ? "N/A" : data.state}</span>
                </td>
                <td className="table-component_table-td">
                  <span>{data.zipcode == null ? "N/A" : data.zipcode}</span>
                </td>
                <td className="table-component_table-td">
									<span className="table-component_table-button" onClick={() => navigate(`/customer/edit/${data.mastercustomerid}`, { state: { data } })}>
										View / Edit
									</span>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </section>
  );
};
